import { IGallery } from '@/_types'
import React from 'react'
import MultipleSlider from '../../GallerySlider'
import { Container, Text } from '@chakra-ui/react'
import dayjs from 'dayjs'
import { useCustomLocale } from '@/_hooks/useCustomLocale'

const Mobile = ({ data }: { data: IGallery }) => {
  const currentLocale = useCustomLocale()

  return (
    <>
      <MultipleSlider data={data?.images} />
      <Container mt={6}>
        <Text>{dayjs(data?.created_at).format('DD.MM.YYYY')}</Text>
        <Text my={3} fontWeight={700} fontSize={20} as='h1'>
          {data?.title?.[currentLocale]}
        </Text>
        <Text fontSize={'sm'}>{data?.description?.[currentLocale]}</Text>
      </Container>
    </>
  )
}

export default Mobile
